import Vue from "vue";
import Vuex from "vuex";
import API from "../api";

const _ = require("lodash");

Vue.use(Vuex);

async function HandleError(callback) {
	try {
		await callback();
	} catch (e) {
		throw e.response.data;
	}
}
const Instance = {
	namespaced: true,
	state: {
		dataList: {	// paginatioin
			total: 0,
			list: []
		},
		ruleForm: {},
	},
	mutations: {},
	actions: {
		async getEduResourceList({ state }, query) {
			await HandleError(async () => {
				state.dataList = (await API.GetEduResourceList(query)).data;
			});
		},
		async createEduResource({ state }, { query, data }) {
			await HandleError(async () => {
				state.dataList = (await API.createEduResource(query, data)).data;
			});
		},
		async updateEduResource({ state }, { query, data }) {
			await HandleError(async () => {
				state.dataList = (await API.updateEduResource(query, data)).data;
			});
		},
		async deleteEduResource({ state }, { query, id }) {
			await HandleError(async () => {
				state.dataList = (await API.deleteEduResource(query, id)).data;
			});
		},
		async getEduResourceDetailLink({ state },{ link }) {
			return (await API.GetEduResourceDetailLink(link)).data;
		},
		async getEduResourceDetailUser({ state },{ account }) {
			return (await API.GetEduResourceDetailUser(account)).data;
		},
	}
};

export default Instance;